module.exports = __webpack_public_path__ + "static/media/tax-search-icon.bc59f9aa.svg";